var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.0002L8 11.0002M11 14.0002C12.3968 13.469 13.7369 12.799 15 12.0002M11 14.0002V19.0002C11 19.0002 14.03 18.4502 15 17.0002C16.08 15.3802 15 12.0002 15 12.0002M8 11.0002C8.53214 9.61968 9.2022 8.29631 10 7.05025C11.1652 5.18723 12.7876 3.6533 14.713 2.59434C16.6384 1.53538 18.8027 0.986619 21 1.00025C21 3.72025 20.22 8.50025 15 12.0002M8 11.0002L3 11.0003C3 11.0003 3.55 7.97026 5 7.00026C6.62 5.92026 10 7.00026 10 7.00026M3.5 15.5002C2 16.7602 1.5 20.5002 1.5 20.5002C1.5 20.5002 5.24 20.0002 6.5 18.5002C7.21 17.6602 7.2 16.3702 6.41 15.5902C6.02131 15.2192 5.50929 15.0048 4.97223 14.9882C4.43516 14.9716 3.91088 15.1539 3.5 15.5002Z",
    stroke: "#18181B",
    strokeWidth: 0.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocket-icon.1c20671c390b4bc66312164923c07528.svg";
export { ForwardRef as ReactComponent };